import { Modal, openModal, setModalWithData, useMsTeamsSelector, usePermissionsSelector, usePersistantAlertHook, usePremiumSelector } from "front";
import { IDialogs } from "../../interfaces/IDialog/IDialogs";
import { useContactListCache } from "../../hooks/useQuery/useContactListCache";
import { useGroupsCache } from "../../hooks/useQuery/useGroupsCache";
import { useUsersCache } from "../../hooks/useQuery/useUsersCache";
import { useCallback, useEffect } from "react";
import { setLimitation, useLimitationSelector } from "../../redux/reducer/LimitationReducer";
import { useDispatch } from "react-redux";
import { IAppDispatch } from "../../redux/store";
import { getLimitation } from "../../apis/actions/contactListAction";

export const useContact = () => {
  const dispatchCtx = useDispatch<IAppDispatch>();

  const { subscription } = useLimitationSelector("subscription", "maxContact");

  const { queryContactList } = useContactListCache();
  const { queryUsers } = useUsersCache();
  const { queryGroups } = useGroupsCache();
  const { isPremium } = usePremiumSelector("isPremium");
  const { tenantId } = useMsTeamsSelector("tenantId");
  const { loaded, userPerm } = usePermissionsSelector("loaded", "userPerm");
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (subscription) return;
    getLimitationAsync();
  }, [subscription]);

  useEffect(() => {
    if (queryContactList.isLoading || queryGroups.isLoading || !userPerm.id || userPerm.cookies) return;
      dispatch(openModal(Modal.COOKIES_ON_START));
  }, [userPerm, queryContactList.isLoading, queryGroups.isLoading])

  const getLimitationAsync = async () => {
    const limitation = await getLimitation(tenantId);
    dispatchCtx(setLimitation(limitation));
  };

  // The tour's "add my first contact": the same dialog as the navbar's "New contact" button.
  const createNewContact = useCallback(() => {
    dispatch(setModalWithData({ isOpen: IDialogs.CONTACT, data: { edit: true, contact: { id: "" } } }));
  }, [dispatch]);

  const isLoading = queryContactList.isLoading || queryGroups.isLoading;

  return {
    isTourReady: !isLoading && !queryUsers.isLoading,
    createNewContact,
    isLoading,
    permsAreLoading: !loaded || !userPerm.id || !subscription,
    contactAreLoading: queryUsers.isLoading,
    error: !!queryContactList.error || !!queryUsers.error,
    isPremium,
  };
};
